import { useMutation, useQuery } from '@tanstack/react-query'
import useHandleAPIError from '@/core/hooks/useHandleAPIError.ts'
import selectServices from '@/core/services/selectServices.ts'
import { useEffect } from 'react'
import articleService from '@/modules/sales/clients/services/articleService.ts'

const useUninstallAppBySupplierLogic = () => {
  const { handleAPIError } = useHandleAPIError()

  const {
    data: brands,
    isLoading: isLoadingBrands,
    error: errorBrands
  } = useQuery({
    queryKey: ['brands'],
    queryFn: () => selectServices.getActiveBrands()
  })

  useEffect(() => {
    if (errorBrands) handleAPIError(errorBrands, 'Error cargando marcas')
  }, [errorBrands, handleAPIError])

  const getSupplierFn = useMutation({
    mutationFn: async ({ brandId }: { brandId: string }) =>
      articleService.getSupplierByBrand(brandId),
    onError: (error) => handleAPIError(error, 'Error obteniendo proveedor')
  })

  const getSupplier = (brandId: string) => {
    return getSupplierFn.mutateAsync({ brandId })
  }

  return {
    brands: { options: brands || [], isLoading: isLoadingBrands },
    getSupplier,
    isLoadingSupplier: getSupplierFn.isPending
  }
}

export default useUninstallAppBySupplierLogic
